import _maxBy from 'lodash/maxBy';
import moment from 'moment';
import pluralize from 'pluralize';
import React, { Component } from 'react';
import { Query } from '@apollo/react-components';
import SpinnerError from '$components/library/SpinnerError';
import { gql } from '@apollo/client';
import chroma from 'chroma-js';
import styles from './styles.scss';

const UPCOMING_WORKLOAD = gql`
  query UpcomingWorkload($input: UpcomingWorkloadInput!) {
    upcomingWorkload(input: $input) {
      hourlyBins {
        numReviewsAvailable
        timestamp
      }
    }
  }
`;

class UpcomingWorkloadChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: 'Touch or hover over a tile for more info',
    };
  }

  setMessage = ({ bin }) => {
    const { numReviewsAvailable, timestamp } = bin;

    const displayDate = moment(timestamp).format('ddd, ha');
    const message = `${pluralize(
      'item',
      numReviewsAvailable,
      true
    )} available at ${displayDate}`;

    this.setState({
      message,
    });
  };

  render() {
    const { product } = this.props;
    const { message } = this.state;
    const { slug: productSlug } = product;

    return (
      <Query
        query={UPCOMING_WORKLOAD}
        variables={{ input: { productSlug } }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          const { upcomingWorkload } = data;
          const { hourlyBins } = upcomingWorkload;

          const maxReviews = _maxBy(
            hourlyBins,
            'numReviewsAvailable'
          ).numReviewsAvailable;
          const backgroundColorScale = chroma
            .scale(['#1a7ec15c', '#40b86c'])
            .domain([0, maxReviews])
            .mode('lch');

          const dataBins = [];
          for (let i = 0; i < 5; i += 1) {
            const binDay = [];

            for (let j = 0; j < 6; j += 1) {
              const binRow = [];

              for (let k = 0; k < 4; k += 1) {
                const index = i * 24 + j * 4 + k;
                const obj = hourlyBins[index];
                binRow.push(obj);
              }

              binDay.push(binRow);
            }

            dataBins.push(binDay);
          }

          return (
            <div data-aaa="upcomingWorkloadChart">
              <div className={styles.chart}>
                {dataBins.map((binDay, dayIndex) => (
                  <div key={dayIndex} className={styles.chartDay}>
                    {binDay.map((binRow, rowIndex) => (
                      <div key={rowIndex} className={styles.chartRow}>
                        {binRow.map((bin) => {
                          const { numReviewsAvailable } = bin;
                          const backgroundColor = numReviewsAvailable
                            ? backgroundColorScale(numReviewsAvailable)
                            : '#ededed';
                          const blockStyle = {
                            backgroundColor,
                          };

                          return (
                            <div
                              key={bin.timestamp}
                              className={styles.chartBlock}
                              style={blockStyle}
                              onClick={() => this.setMessage({ bin })}
                              onMouseOver={() => this.setMessage({ bin })}
                            />
                          );
                        })}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className={styles.chartLabels}>
                <div className={styles.chartLabel}>Now</div>
                <div className={styles.chartLabel}>+24hrs</div>
                <div className={styles.chartLabel}>+48hrs</div>
                <div className={styles.chartLabel}>+72hrs</div>
                <div className={styles.chartLabel}>+96hrs</div>
              </div>
              <div className={styles.chartMessage}>{message}</div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default UpcomingWorkloadChart;
